import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router';

export default ({
  currentPage, toggleHelpOptions, openSupportModal, orderSupportInfoCommon,
  cards, orderId, orderUUID, renderCardHelpButtons, userActions
}) => {
  const buttonFunc = e => openSupportModal(e, { ...orderSupportInfoCommon, orderId });
  return (
    <thead>
      <tr>
        <th className="font-weight-normal">
          <button className="acct-pg-btn" onClick={buttonFunc}>Help</button>
        </th>
        <th>Merchant</th>
        <th>Card ID</th>
        <th>Ref ID</th>
        <th>Number</th>
        <th>Value</th>
        <th>Type</th>
        <th>Offer Amount</th>
      </tr>
    </thead>
  )
}
